// @flow

import * as React from 'react';

import { useField, useForm } from 'react-final-form';

import { useTranslator } from '@gandi/translate';
import {
  InputNumber,
  InputNumberInput,
  InputNumberStepDown,
  InputNumberStepUp,
} from '@gandi/ui';

import { MAILBOX_COUNT_INPUT_NAME } from '../consts';
import type { FormValues } from '../types/form';

const config: {
  min: number,
  max: number,
  step: number,
} = {
  min: 0,
  max: 100,
  step: 1,
};

export function MailboxCounter(): React.MixedElement {
  const { __ } = useTranslator();
  const form = useForm<FormValues>();
  const {
    input: { value: count },
    // $FlowFixMe[prop-missing]
  } = useField(MAILBOX_COUNT_INPUT_NAME, { subscription: { value: true } });
  const value = parseInt(count || 0, 10);
  const handleInputChange = (val: mixed) => {
    if (val === '') {
      form.change(MAILBOX_COUNT_INPUT_NAME, val);
    } else if (typeof val === 'number' && !Number.isNaN(val)) {
      if (val >= config.max) {
        form.change(MAILBOX_COUNT_INPUT_NAME, config.max);
      } else if (val <= config.min) {
        form.change(MAILBOX_COUNT_INPUT_NAME, config.min);
      } else {
        form.change(MAILBOX_COUNT_INPUT_NAME, val);
      }
    }
  };
  return (
    <InputNumber small>
      <InputNumberStepDown
        disabled={value <= config.min}
        onClick={() => handleInputChange(value - config.step)}
      >
        {__('Less')}
      </InputNumberStepDown>
      <InputNumberInput
        style={{ maxWidth: '100px' }}
        {...config}
        value={count === '' ? count : value}
        onChange={evt => {
          const val = evt.target.value;
          handleInputChange(val === '' ? val : evt.target.valueAsNumber);
        }}
      />
      <InputNumberStepUp
        disabled={value >= config.max}
        onClick={() => handleInputChange(value + config.step)}
      >
        {__('More')}
      </InputNumberStepUp>
    </InputNumber>
  );
}
